import { PHONE_COUNTRY_OPTIONS } from '@shared/constants';

export const SORTED_OPTIONS = [...PHONE_COUNTRY_OPTIONS].sort(
	(a, b) => b.value.length - a.value.length,
);

export const toPlaceholder = (localMask) => localMask.replace(/0/g, '9');

export const DEFAULT_PHONE_PLACEHOLDER = `${PHONE_COUNTRY_OPTIONS[0].value} ${toPlaceholder(PHONE_COUNTRY_OPTIONS[0].localMask)}`;

const escapeCode = (code) => code.replace(/0/g, '\\0');

const GENERIC_MASK = { mask: '+000000000000000', countryValue: '' };

const PHONE_MASKS = [
	GENERIC_MASK,
	...SORTED_OPTIONS.map((o) => ({
		mask: escapeCode(o.value) + ' ' + o.localMask,
		countryValue: o.value,
	})),
];

export const MASK_OPTIONS = {
	mask: PHONE_MASKS,
	dispatch: (appended, dynamicMasked) => {
		const raw = (dynamicMasked.value + appended).replace(/\s/g, '');
		const normalized = raw.startsWith('+') ? raw : '+' + raw;

		const exact = dynamicMasked.compiledMasks.find(
			(m) => m.countryValue && normalized.startsWith(m.countryValue),
		);
		return exact ?? dynamicMasked.compiledMasks[0];
	},
};

export const detectCountry = (displayOrE164) => {
	if (!displayOrE164) return null;
	const stripped = displayOrE164.replace(/\s/g, '');
	return SORTED_OPTIONS.find((o) => stripped.startsWith(o.value)) ?? null;
};

export const e164ToDisplay = (e164) => {
	if (!e164) return '';
	const option = SORTED_OPTIONS.find((o) => e164.startsWith(o.value));
	if (!option) return e164;
	const localDigits = e164.slice(option.value.length);
	let result = option.value + ' ';
	let di = 0;
	for (const char of option.localMask) {
		if (di >= localDigits.length) break;
		result += char === '0' ? localDigits[di++] : char;
	}
	return result;
};
